import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import CoursesContent from './CoursesContent'
export default class Users extends Component {



    render() {
        let page = this.props.match.params.page;

        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <CoursesContent page={page} />
                <Footer />

            </div>


        )
    }
}
